import { call, put } from 'redux-saga/effects';
import { loginRequest, loginSuccess, loginFailure, setSystemSuspending } from '../../state/login/loginSlice';
import { setUserCredentials } from '../../state/userCredential/userCredentialSlice';
import {
    applyAuthConfig
} from '../../state/config/configSlice';
import { startTokenRefreshTimerAction } from '../auth/startTokenRefreshTimer/action';
import { checkDeviceAction, fetchSMSNumberAction } from '../device/action';
import { fetchPortalConfigAction } from '../portalConfig/fetchPortalConfig/action';
import { postLoginAction } from '../postLogin/action';
import { backendClient } from '../../services/api/backend-client';
import { setBugsnagUser } from '../../services/bugsnag/bugsnag';
import { setDefaultBackground } from '../../state/background/backgroundSlice';
import { getDefaultBackground } from '../../browser/storage';
import { getDeviceId, getAppVersion } from '../../browser/deviceIdentity';

export function* loginSaga(action) {
    const { username, password } = action.payload;
    try {
        //Loading Background behore
        const savedBackground = yield call(getDefaultBackground);
        yield put(setDefaultBackground(savedBackground));

        //Get deviceId and appVersion
        const deviceId = yield call(getDeviceId)
        const appVersion = yield call(getAppVersion);

        // Dispatch loginRequest to handle the loading state and set isSuspending to false
        yield put(loginRequest());
        yield put(setSystemSuspending(false));

        const { data } = yield call(
            [backendClient, backendClient.post],
            'auth/login',
            { username, password, appVersion, deviceId, platform: 'web' }
        );

        const {
            access_token, displayName, uid, user, email, group, domain, expires_in, scope, jwt,
            role, userPreferences, crmEnabled, crmTypes, storageEnabled, storageTypes, defaultCrm, analyticsEnabled, analyticsProcessingEnabled, callIngestion, analyticsMinDuration, callAssistantEnabled, chatAssistantEnabled, domainConfig, wsServers, esServer
        } = data;
        const expirationTime = Date.now() + expires_in * 1000; // Calculate expiration timestamp

        yield put(loginSuccess());

        yield put(setUserCredentials({
            jwt,
            access_token,
            displayName,
            uid,
            user,
            email,
            group,
            domain,
            expirationTime,
            scope,
            role,
            defaultCrm,
            analyticsProcessingEnabled,
            callAssistantEnabled,
            chatAssistantEnabled,
            userPreferences,
        }));
        yield put(applyAuthConfig({
            wsServers, esServer, callIngestion, analyticsMinDuration, analyticsEnabled,
            crmEnabled, crmTypes, storageEnabled, storageTypes, domainConfig,
        }));

        // Start the token refresh timer
        yield put(startTokenRefreshTimerAction());
        // Trigger device check and fetch user Number
        yield put(checkDeviceAction(true)); // Attempt to create if not found
        yield put(fetchSMSNumberAction());

        setBugsnagUser(uid, displayName, email);// setup bugnag user

        yield put (fetchPortalConfigAction())

        //Handle all postLogin operations
        yield put(postLoginAction())


    } catch (error) {
        console.error('Login attempt failed:', error);
        yield put(loginFailure());
    }
}